import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useGetAllForParentSubCategoryQuery } from "../../redux/api/categoryApi";

const SubCategoryItem = ({
  showBtn = true,
  parentCategory,
  href,
  children,
}) => {
  const [showSubCategory, setShowSubCategory] = useState(false);
  const { data: subCategoryData } = useGetAllForParentSubCategoryQuery(
    parentCategory?._id
  );

  const toggleSubCategory = (event) => {
    event.stopPropagation(); // Prevents the parent button's onClick from triggering
    setShowSubCategory(!showSubCategory);
  };

  return (
    <li className="w-full flex flex-col gap-2">
      <button
        className="flex items-center w-full justify-between gap-12"
        onClick={toggleSubCategory}
      >
        <Link
          to={href}
          className="break-before-all text-left break-words hover:text-orange-400 transition-colors duration-300 ease-in-out"
        >
          {children}
        </Link>
        {showBtn && (
          <i
            onClick={toggleSubCategory}
            className={`fas ${
              showSubCategory ? "fa-angle-down" : "fa-angle-right"
            } shrink-0`}
          ></i>
        )}
      </button>

      {subCategoryData?.data?.length > 0 && showSubCategory && (
        <ul className="flex flex-col gap-3 pl-10">
          {subCategoryData.data.map((subItem) => (
            <li key={subItem._id}>
              <Link
                to={`/category/${subItem._id}`}
                className="break-before-all text-left break-words hover:text-orange-400 transition-colors duration-300 ease-in-out"
              >
                {subItem.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SubCategoryItem;
